import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const AcademicYearHistory = lazy(() => import('../pages/academic-year/AcademicYearHistory'));
const PromotionPaths = lazy(() => import('../pages/academic-year/PromotionPaths'));

const AcademicYearRoutes = () => {
  return (
    <Routes>
      <Route path="history" element={<AcademicYearHistory />} />
      <Route path="promotion-paths" element={<PromotionPaths />} />
    </Routes>
  );
};

export default AcademicYearRoutes;
